/**
 * Tiny form primitives shared by the NiV payment cards (ncpp-* CSS).
 */

export function Switch({ checked, onChange, label, disabled }) {
  return (
    <label className="ncpp-switch-row">
      <span>{label}</span>
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        className={`ncpp-switch${checked ? " is-on" : ""}`}
        onClick={() => onChange(!checked)}
        disabled={disabled}
      >
        <span className="ncpp-switch-knob" />
      </button>
    </label>
  );
}

export function Segmented({ options, value, onChange, disabled = false, toneByValue = null }) {
  return (
    <div className="ncpp-segment" role="radiogroup">
      {options.map((opt) => {
        const active = value === opt.value;
        const tone = toneByValue?.[opt.value];
        return (
          <button
            key={opt.value}
            type="button"
            role="radio"
            aria-checked={active}
            className={`ncpp-segment-btn${active ? " is-active" : ""}${tone ? ` ncpp-tone-${tone}` : ""}`}
            onClick={() => onChange(opt.value)}
            disabled={disabled}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}

export function CardHead({ icon: Icon, eyebrow, title, children }) {
  return (
    <header className="ncpp-card-head">
      <span className="ncpp-card-icon">
        <Icon size={15} weight="bold" />
      </span>
      <div className="ncpp-card-titles">
        <span className="ncpp-card-eyebrow">{eyebrow}</span>
        <h3 className="ncpp-card-title">{title}</h3>
      </div>
      {children}
    </header>
  );
}
